import { render, staticRenderFns } from "./companyActive.vue?vue&type=template&id=209ebb37&scoped=true&"
import script from "./companyActive.vue?vue&type=script&lang=js&"
export * from "./companyActive.vue?vue&type=script&lang=js&"
import style0 from "./companyActive.vue?vue&type=style&index=0&id=209ebb37&scoped=true&lang=css&"
import style1 from "./companyActive.vue?vue&type=style&index=1&id=209ebb37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209ebb37",
  null
  
)

export default component.exports